<template>
  <div class="inner_app">
    <div id="kakaoIndex">
      <a href="#kakaoBody">본문 바로가기</a>
      <a href="#kakaoGnb">메뉴 바로가기</a>
    </div>
    <div id="kakaoWrap" :class="['wrap_brand',{'scrolled' : isScrolled}]">
      <Header />
      <hr class="hide">
      <Content>
        <slot />
      </Content>
      <hr class="hide">
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from '@/components/layout/header/Header.vue'
import Content from '@/components/layout/content/Content.vue'
import Footer from '@/components/layout/footer/Footer.vue'
import Scrolled from '@/mixins/Scrolled'

export default {
  name: 'PageWithLayout',
  components: {
    Header,
    Content,
    Footer,
  },
  mixins: [
    Scrolled
  ],
  props: {
    pageTitle: String,
  },
}
</script>
<style scoped>
.inner_app{height:100%}
.wrap_brand.scrolled >>> .k_head{background-color:#fff}
</style>
